import { Table } from 'antd';
import moment from 'moment';
import { capitalize, capitalizeFirstLetter, formatMoney, getRandomColor } from '../../../utils';
import useFetchDispatch from '../../../custom_hooks/useFetchDispatch';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchSettlements } from '../../../features/money/moneySlice';
import TableLoading from '../../../components/TableLoading';
import { statusColor } from '../../../data';

const columns = [
    {
        title: 'Date',
        dataIndex: 'withDrawCreatedDate',
        render: (item) => <span>{moment(item).format('Do MMM YYYY')}</span>,
    },
    {
        title: 'Amount',
        dataIndex: 'withDrawAmount',
        render: (item) => <span>{formatMoney(item, 'KES')}</span>,
    },
    {
        title: 'Particulars',
        dataIndex: 'withDrawParticular',
        render: (item) => <span>{capitalizeFirstLetter(item)}</span>,
    },
    {
        title: 'Recipient Name',
        render: (item) => (
            <span>
                {item?.withDrawType === 'BANK' ? (
                    <>
                        <div className="w-full flex items-center gap-[.5rem]">
                            <img
                                src={`https://ui-avatars.com/api/?name=${encodeURIComponent(item?.withDrawBankName)}&background=${getRandomColor()}&color=fff`}
                                className="w-[2.1875rem] h-[2.1875rem] rounded-full object-cover"
                                alt="avatar"
                            />
                            <span>{item?.withDrawBankName}</span>
                        </div>
                    </>
                ) : (
                    ' - '
                )}
            </span>
        ),
    },
    {
        title: 'Recipient account',
        render: (item) => <span>{item?.withDrawType === 'BANK' ? <>{item?.withDrawAccountNumber}</> : item?.withDrawMpesaNumber}</span>,
    },
    {
        title: 'Source account',
        dataIndex: 'withDrawCwCollection',
    },
    {
        title: 'Type',
        dataIndex: 'withDrawType',
    },
    {
        title: 'Status',
        dataIndex: 'withDrawStatus',
        render: (status) => {
            const statusBackgroundColor = statusColor.find(({ label }) => label.toUpperCase() === status.toUpperCase())?.value || '#F6F6F6';

            return (
                <div
                    style={{
                        background: statusBackgroundColor,
                    }}
                    className="flex flex-shrink-0 w-full min-h-[1.8rem] h-auto items-center justify-center gap-[.5rem] px-[.5rem] py-[.25rem]"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="5" height="4" viewBox="0 0 5 4" fill="none">
                        <circle cx="2.66602" cy="2" r="2" fill="#212121" />
                    </svg>
                    <span className="w-full truncate">{capitalize(status=== 'PENDING_OTP_VALIDATION' ? 'Cancelled' : status.split('_').join(' '))}</span>
                </div>
            );
        },
    },
];

export default function AllWithdrawalsTable() {
    const { isLoading } = useFetchDispatch(fetchSettlements);

    const { settlements } = useSelector((state) => state.money);

    useEffect(() => {}, [settlements]);

    if (isLoading) return <TableLoading />;

    return (
        <>
            <Table
                scroll={{
                    x: 1300,
                }}
                rowKey="withDrawId"
                className="mt-[1.5rem] !w-full"
                pagination={{
                    defaultPageSize: 7,
                    hideOnSinglePage: true,
                    pageSizeOptions: [10, 20, 50, 100],
                }}
                columns={columns}
                dataSource={settlements}
            />
        </>
    );
}
